import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

// Import components
import { ProgramRecordings } from 'components/elements';
import Share from './share/Share';
import { Reminder } from '../../common';

// Import utilities
import { useAuth } from 'components/utilities';
import useProgramToolbar from 'components/views/tv/program_details/program_toolbar/useProgramToolbar';

// Import styles
import { ToolBox, Box } from './styles';

const PopoverToolbox = ({
	reminderId,
	programId,
	isUpcoming = false,
	theme,
	startDate
}) => {
	const { isAuth } = useAuth();
	const { isRecordingsPanelVisible, isNpvrActive } = useProgramToolbar();

	const reminderProps = { reminderId, theme, programId, startDate };

	return (
		<ToolBox>
			{isUpcoming && isAuth && (
				<Box>
					<Reminder {...reminderProps} />
				</Box>
			)}

			{isAuth && isRecordingsPanelVisible && (
				<Box>
					<ProgramRecordings
						programId={programId}
						isNpvrActive={isNpvrActive}
					/>
				</Box>
			)}
			<Box>
				<Share />
			</Box>
		</ToolBox>
	);
};

PopoverToolbox.propTypes = {
	isUpcoming: PropTypes.bool.isRequired,
	programId: PropTypes.string.isRequired,
	reminderId: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([false])]),
	startData: PropTypes.string.isRequired
};

export default withTheme(PopoverToolbox);
